var _path, _path2, _path3, _path4;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgEducationCenter(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M21.1875 12.2625H14.2125V2.88752C14.2125 1.80002 13.3125 0.900024 12.225 0.900024H10.3875C5.13755 0.937524 0.862549 5.21252 0.862549 10.5V21.1125C0.862549 22.2 1.76255 23.1 2.85005 23.1H21.225C22.3125 23.1 23.2125 22.2 23.2125 21.1125V14.25C23.175 13.1625 22.275 12.2625 21.1875 12.2625ZM12.525 21.375H2.81255C2.66255 21.375 2.51255 21.2625 2.51255 21.075V10.5C2.51255 6.15002 6.03755 2.62502 10.3875 2.62502H12.225C12.375 2.62502 12.525 2.73752 12.525 2.92502V12.3V21.375ZM17.3251 21.375V19.5C17.3251 19.125 17.625 18.8625 17.9625 18.8625C18.3375 18.8625 18.6 19.1625 18.6 19.5V21.375H17.3251ZM21.4875 21.1125C21.4875 21.2625 21.375 21.4125 21.1875 21.4125H20.3251V19.5375C20.3251 18.2625 19.275 17.2125 18 17.2125C16.725 17.2125 15.675 18.2625 15.675 19.5375V21.4125H14.2125V13.95H21.1875C21.3375 13.95 21.4875 14.0625 21.4875 14.25V21.1125Z",
    fill: "inherit",
    stroke: "none",
    fillOpacity: 0.7
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M8.13765 7.72498H7.01265C6.56265 7.72498 6.15015 8.09998 6.15015 8.58748C6.15015 9.07498 6.52515 9.44998 7.01265 9.44998H8.13765C8.58765 9.44998 9.00015 9.07498 9.00015 8.58748C9.00015 8.09998 8.58765 7.72498 8.13765 7.72498Z",
    fill: "inherit",
    stroke: "none",
    fillOpacity: 0.7
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M8.13765 12.15H7.01265C6.56265 12.15 6.15015 12.525 6.15015 13.0125C6.15015 13.5 6.52515 13.875 7.01265 13.875H8.13765C8.58765 13.875 9.00015 13.5 9.00015 13.0125C9.00015 12.525 8.58765 12.15 8.13765 12.15Z",
    fill: "inherit",
    stroke: "none",
    fillOpacity: 0.7
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M8.13765 16.6125H7.01265C6.56265 16.6125 6.15015 16.9875 6.15015 17.475C6.15015 17.9625 6.52515 18.3375 7.01265 18.3375H8.13765C8.58765 18.3375 9.00015 17.9625 9.00015 17.475C9.00015 16.9875 8.58765 16.6125 8.13765 16.6125Z",
    fill: "inherit",
    stroke: "none",
    fillOpacity: 0.7
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEducationCenter);
export default __webpack_public_path__ + "static/media/education-center.c746e841c339ad8c109ea976ef494dd0.svg";
export { ForwardRef as ReactComponent };